<template>
  <section class="promo">
    <div class="section-wrap">
      <Header dark :trigger="trigger"/>
    </div>
    <div class="container">
      <h1 class="promo__head">if you need help with digital design, innovation or development, we are the right people to help you.</h1>
      <p class="promo__text">we have experience in telecom, medical, pharma, bank, pension and many more…</p>
      <p class="promo__sub-text">let’s already start something together today!</p>
      <router-link class="promo__cta" :to="{ name: 'Contact', params: {} }">find us here <span class="link promo__cta__btn"></span></router-link>
    </div>
  </section>
</template>

<script>
import './style.scss';
import Header from '@/components/Header/Header';

export default {
  name: 'Promo',
  data() {
    return {
    };
  },
  methods: {
  },
  components: {
    Header,
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Promo/Promo.vue